import { AxiosInterceptor } from "api/core/consts";

export const shipmentInspectionItemType = {
  searchShipmentInspectionItemType: (body) => AxiosInterceptor.post('shipmentInspectionItemType/search', body),
  createShipmentInspectionItemType: (body) => AxiosInterceptor.post('shipmentInspectionItemType', body),
  updateShipmentInspectionItemType: (shipmentInspectionItemTypeId, body) => AxiosInterceptor.put('shipmentInspectionItemType/' + shipmentInspectionItemTypeId, body),
  deleteShipmentInspectionItemType: (shipmentInspectionItemTypeId) => AxiosInterceptor.delete('shipmentInspectionItemType/' + shipmentInspectionItemTypeId),
};
